import { FC, HTMLAttributes } from 'react';

type NightlyWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const NightlyWallet: FC<NightlyWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={size}
      height={size}
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 960 960"
      fill="none"
      {...props}
    >
      <path fill="#6067f9" d="M0 0h960v960H0z"></path>
      <path
        fill="#f7f7f7"
        d="M702.9 192c-42.2 58.9-94.9 99.7-157.3 126.9-21.6-6-43.9-9-65.7-8.8-21.9-.2-44.1 2.9-65.7 8.8-62.3-27.4-115.1-68-157.3-126.9-12.7 32-61.8 142.5-2.9 297 0 0-18.8 80.6 15.8 149.8 0 0 50.1-22.7 89.9 9.2 41.6 33.7 28.3 66.2 57.6 94.1 25.3 25.8 62.8 25.8 62.8 25.8s37.5 0 62.8-25.7c29.3-27.8 16.1-60.3 57.6-94.1 39.7-31.9 89.9-9.2 89.9-9.2 34.5-69.2 15.8-149.8 15.8-149.8 58.5-154.6 9.6-265.1-3.3-297.1M285.4 467.7c-32-65.7-40.8-155.9-20.6-227.2 26.7 67.6 63 98 106.2 130-18.3 38-52.7 73.8-85.6 97.2m92.1 115.7c-25.3-11.2-30.6-33.1-30.6-33.1 34.4-21.6 85-5.1 86.6 46.1-26.6-16.1-35.5-4.1-56-13m102.4 181.8c-18 0-32.7-13-32.7-28.9s14.7-28.9 32.7-28.9 32.7 13 32.7 28.9c0 16-14.6 28.9-32.7 28.9m102.6-181.8c-20.5 9-29.3-3.2-56 13 1.7-51.2 52.1-67.8 86.6-46.1 0-.1-5.4 22-30.6 33.1m92-115.7c-32.8-23.3-67.3-59.1-85.7-97.2 43.2-32 79.6-62.5 106.2-130 20.5 71.2 11.7 161.5-20.5 227.2"
      ></path>
    </svg>
  );
};

export default NightlyWallet;
